<template>
  <section class="questions-container">
    <div>
      <router-link
        class="btn btn-info"
        tag="button"
        :to="{ name: 'NewCampaignQuestion', params: { campaignId: campaignId }, query: { updatedAt } }"
      >
        <i class="mdi mdi-playlist-plus"></i> Add Question & Answer
      </router-link>
    </div>
    <spinner v-if="showSpinner" fullScreen />
    <div v-else class="questions mt-5" ref="questionsList">
      <div class="question pb-3" v-for="question of campaignQuestions">
        <section class="question-text">
          <h5>{{question.question}}</h5>
        </section>
        <section v-if="question.answer" class="answer">
          <p class="answer-text">{{question.answer}}</p>
        </section>
        <section class="question-menu">
          <router-link
                  class="btn btn-outline-secondary btn-xs"
                  tag="button"
                  :to="{ name: 'EditCampaignQuestion', params: { questionId: question.id }, query: { question: question.question, answer: question.answer, updatedAt } }"
          >
            <i class="mdi mdi-lead-pencil"></i> Edit
          </router-link>
          <button
                  class="btn btn-outline-danger btn-xs ml-2"
                  @click="removeQuestion(question.id)"
          >
            <i class="mdi mdi-delete"></i> Delete
          </button>
        </section>
      </div>
    </div>
  </section>
</template>
<script>
import swal from 'sweetalert2';
import { mapGetters } from 'vuex';
import QUESTIONS from '@/graphql/Campaigns/Questions.gql';
import REMOVE_QUESTION from '@/graphql/Campaigns/RemoveQuestion.gql';

const DEFAULT_QUESTIONS_LIMIT = 7;

export default {
  props: {
    campaignId: Number,
    updatedAt: Number,
  },
  computed: {
    ...mapGetters(['getAuthUser']),
    limit() {
      return DEFAULT_QUESTIONS_LIMIT;
    },
  },
  mounted() {
    this.$refs.questionsList.addEventListener('scroll', this.onPagination);
  },
  beforeDestroy() {
    this.$refs.questionsList.removeEventListener('scroll', this.onPagination);
  },
  data() {
    return {
      campaignQuestions: [],
      showSpinner: false,
      offset: 0,
      ended: false,
    };
  },
  methods: {
    onPagination({ target }) {
      const isBottom = target.scrollHeight === target.scrollTop + target.offsetHeight;
      if (this.ended || !isBottom) {
        return;
      }
      this.offset += this.limit;
      this.updateQuestions(olderQuestions => this.campaignQuestions.concat(olderQuestions));
    },
    async updateQuestions(map = a => a) {
      const {
        data: {
          campaignQuestions: {
            result,
            meta: { count },
          },
        },
      } = await this.fetchQuestions();
      this.campaignQuestions = map(result);
      this.ended = this.campaignQuestions.length === count;
    },
    fetchQuestions() {
      return this.$apollo.query({
        query: QUESTIONS,
        loadingKey: 'showSpinner',
        fetchPolicy: 'network-only',
        variables: {
          campaignId: this.campaignId,
          limit: this.limit,
          offset: this.offset,
        },
      });
    },
    async removeQuestion(questionId) {
      const { value: isConfirmed } = await swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Yes, delete it!',
      });
      if (!isConfirmed) {
        return;
      }
      this.campaignQuestions = this.campaignQuestions.filter(q => q.id !== questionId);
      return this.$apollo.mutate({
        mutation: REMOVE_QUESTION,
        variables: { questionId },
      });
    },
  },
  apollo: {
    campaignQuestions: {
      query: QUESTIONS,
      loadingKey: 'showSpinner',
      fetchPolicy: 'network-only',
      variables() {
        return {
          campaignId: this.campaignId,
          limit: this.limit,
          offset: 0,
        };
      },
      result({ data, loading }) {
        if (loading) {
          return;
        }
        this.campaignQuestions = data.campaignQuestions.result;
      },
    },
  },
  watch: {
    updatedAt() {
      this.offset = 0;
      this.updateQuestions();
    },
  },
};
</script>
<style scoped>
.questions {
  flex: 1;
  display: flex;
  flex-direction: column;
  list-style: none;
}

.question {
  margin-bottom: 20px;
}

.answer-text {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Campaigns/Details/Questions.vue